var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCursor = function SvgCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.258 4.993a.5.5 0 0 0-.657.656l5.493 12.797a.5.5 0 0 0 .907.025l1.65-3.312 3.11 3.274a1.435 1.435 0 0 0 2.109-1.944l-3.089-3.453 3.298-1.655a.5.5 0 0 0-.027-.906L6.258 4.993z",
    fill: "#fff"
  })));
};
export default SvgCursor;